import React, { useState, useEffect } from 'react';
import {
  DatatableRiskHeatmap,
  ActionBarRiskHeatmapComp,
  FilterRiskHeatmapComp,
  ChartHeatmapDivision,
  DatatableMonitoringProfile,
} from '../../components';
import axios from '../../library/axios';
import errorHandler from '../../helpers/errorHandler';
import { useLocation } from 'react-router-dom';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { MySwal } from '../../library/swal';
import { validationAccess } from "../../helpers/validationAccess"
import { getModule, setHrefWithSlugHook, } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";
import { notifyApiError, notifyApiLoadError } from '../../helpers/notifyApiError';

const RiskHeatmapPage = () => {
  const location = useLocation();
  const [search, setSearch] = useState([]);
  const [filterHeatmap, setfilterHeatmap] = useState([]);
  const [listHeatmap, setlistHeatmap] = useState([]);
  const [filterMonitoringProfile, setfilterMonitoringProfile] = useState([]);
  const [listMonitoringProfile, setlistMonitoringProfile] = useState([]);
  const [idRiskBobot, setidRiskBobot] = useState([]);
  const [startDate, setstartDate] = useState([]);
  const [endDate, setendDate] = useState([]);
  const [dataExport, setdataExport] = useState({});
  const [role, setRole] = useState('');
  const fileName = 'listRiskHeatmap';
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const exportToCSV = (apiData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const handleExport = async () => {
    if (filterHeatmap.length === 0) {
      MySwal.fire({
        icon: 'info',
        title: 'Info Error Message!',
        text: 'Anda belum memilih Agenda.',
      });
      return false;
    }
    const exportData = filterHeatmap.map((heatmap) => ({
      'Nama Kegiatan': heatmap.risk_activity_target?.name,
      'Tujuan Kegiatan': heatmap.risk_activity_target?.goals,
      Area: heatmap.area,
      Sebab: heatmap.causeOfTheIncident,
      'Kode Risiko': 'R.' + heatmap.codeRisk,
      Risiko: heatmap.risk,
      Dampak: heatmap.impact,
      'Pernyataan Risiko': heatmap.riskStatement,
      Dampak: heatmap.impactAnalysis,
      Probabilitas: heatmap.probabilityAnalysis,
    }));
    exportToCSV(exportData, fileName);
  };

  const handleFilter = (idRiskBobot, startDate, endDate) => {
    fetchData(idRiskBobot, startDate, endDate);
    setidRiskBobot(idRiskBobot);
  };

  const fetchData = async (idRiskBobot, startDate, endDate) => {
    const config = {
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
      },
    };

    const requestBody = {
      idRiskBobot: idRiskBobot,
      startDate: startDate,
      endDate: endDate,
    };

    setlistHeatmap([]);
    setfilterHeatmap([]);
    setlistMonitoringProfile([]);
    setfilterMonitoringProfile([]);
    axios
      .post('/risk-heatmap/filterHeatmap', requestBody, config)
      .then((res) => {
        if (res?.data?.riskRegisters?.length === 0) {
          MySwal.fire({
            icon: 'info',
            title: 'Info Error Message!',
            text: `Data tidak ditemukan.`,
          });
          return false;
        }
        if (res.status === 200) {
          setlistHeatmap(res?.data?.riskRegisters);
          setfilterHeatmap(res?.data?.riskRegisters);
          setlistMonitoringProfile(res?.data?.riskProfiles);
          setfilterMonitoringProfile(res?.data?.riskProfiles);
        }
      })
      .catch((err) => {
        notifyApiError(err, { context: 'pages/risk-heatmap/index.fetchData' });
        // if (err !== '') {
        //   errorHandler({ err: err?.response?.data || err });
        // }
      });
  };

  const fetchLoginStatus = async () => {
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook("/login");
        }, 3000);
      } else {
        // console.log(data?.data?.mapping_groups[0].module.pathModule)
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            localStorage.clear();
            setHrefWithSlugHook("/login");
          }, 3000);
        }
      }
    } catch (err) {
      notifyApiLoadError(err, 'pages/risk-heatmap/index.fetchLoginStatus');
    }
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      notifyApiLoadError(err, 'pages/risk-heatmap/index.fetchOneUser');
    }
  };

  useEffect(() => {
    fetchLoginStatus();
    fetchOneUser();
  }, []);

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  // useEffect(() => {
  //   const result = filterHeatmap?.filter((item) => {
  //     console.log(result);

  //     let codeRisk = item.codeRisk;
  //     let impactAnalysis = item.impactAnalysis;
  //     let probabilityAnalysis = item.probabilityAnalysis;

  //     return codeRisk
  //       .concat(impactAnalysis)
  //       .concat(probabilityAnalysis)
  //       .toLowerCase()
  //       .match(search.toString().toLowerCase());
  //   });
  //   setlistHeatmap(result);
  // }, [search]);

  return (
    <>
      {/*begin::Content*/}
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        {/*begin::Toolbar*/}
        <div className="toolbar" id="kt_toolbar">
          {/*begin::Container*/}
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            {/*begin::Page title*/}
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              {/*begin::Title*/}
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                Dashboard Pemantauan Manajemen Risiko
                {/*begin::Separator*/}
                <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                {/*end::Separator*/}
                {/*begin::Description*/}
                <small className="text-muted fs-7 fw-bold my-1 ms-1">
                  #SPEAK_VERSI_RS
                </small >
                {/*end::Description*/}
              </h1 >
              {/*end::Title*/}
            </div >
            <ActionBarRiskHeatmapComp
              handleExport={handleExport}
              listRiskHeatmap={filterHeatmap}
            />
            {/*end::Page title*/}
          </div >
          {/*end::Container*/}
        </div >
        {/*end::Toolbar*/}
        <FilterRiskHeatmapComp
          doFilter={(param1, param2, param3) =>
            handleFilter(param1, param2, param3)
          }
        />
        {
          listHeatmap.length > 0 ? (
            <>
              {/*begin::Post*/}
              <div className="post d-flex flex-column-fluid" id="kt_post">
                {/*begin::Container*/}
                <div id="kt_content_container" className="container-xxl">
                  {/*begin::Row*/}
                  <div className="row gy-5 g-xl-8">
                    {/*begin::Col*/}
                    <div className="col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <DatatableRiskHeatmap
                            listRiskHeatmap={listHeatmap}
                            search={search}
                            role={role}
                            handleChangeSearch={handleChangeSearch}
                          />
                        </div>
                      </div>
                    </div>
                    {/*end::Col*/}
                  </div>
                  {/*end::Row*/}
                </div>
                {/*end::Container*/}
              </div>
              {/*end::Post*/}

              {/*begin::Post*/}
              <div className="post d-flex flex-column-fluid" id="kt_post">
                {/*begin::Container*/}
                <div id="kt_content_container" className="container-xxl">
                  {/*begin::Row*/}
                  <div className="row gy-5 g-xl-8">
                    {/*begin::Col*/}
                    <div className="col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <ChartHeatmapDivision listRiskHeatmap={listHeatmap} />
                        </div>
                      </div>
                    </div>
                    {/*end::Col*/}
                  </div>
                  {/*end::Row*/}
                </div>
                {/*end::Container*/}
              </div>
              {/*end::Post*/}
            </>
          ) : (
            ''
          )}

        {listMonitoringProfile.length > 0 ? (
          <>
            {/*begin::Post*/}
            <div className="post d-flex flex-column-fluid" id="kt_post">
              {/*begin::Container*/}
              <div id="kt_content_container" className="container-xxl">
                {/*begin::Row*/}
                <div className="row gy-5 g-xl-8">
                  {/*begin::Col*/}
                  <div className="col-xl-12">
                    <div className="card">
                      <div className="card-body">
                        <DatatableMonitoringProfile
                          listMonitoringProfil={listMonitoringProfile}
                          search={search}
                          role={role}
                          handleChangeSearch={handleChangeSearch}
                        />
                      </div>
                    </div>
                  </div>
                  {/*end::Col*/}
                </div>
                {/*end::Row*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Post*/}
          </>
        ) : (
          ''
        )
        }
      </div >
      {/*end::Content*/}
    </>
  );
};

export default RiskHeatmapPage;
